'use strict';

var tslib = require('tslib');
var React = require('react');
var superEllipse = require('@alfalab/core-components/icon-view/super-ellipse');
var UserLineMIcon = require('@alfalab/icons-glyph/UserLineMIcon');
var CrossMWhiteIcon = require('@alfalab/icons-glyph/CrossMWhiteIcon');
var vars = require('@alfalab/core-components/vars');
var core_statusScreen_statusScreen = require('../../status-screen.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var ERROR_ICONS_MAP = {
    block: React__default.default.createElement(UserLineMIcon.UserLineMIcon, null),
    fail: React__default.default.createElement(CrossMWhiteIcon.CrossMWhiteIcon, null),
};
var StatusScreenError = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'block' : _b, restProps = tslib.__rest(_a, ["type"]);
    var bgColor = type === 'block' ? vars.colorDarkBgSecondaryInverted : vars.colorLightGraphicNegative;
    var topAddon = (React__default.default.createElement(superEllipse.SuperEllipse, { backgroundColor: bgColor }, ERROR_ICONS_MAP[type]));
    return React__default.default.createElement(core_statusScreen_statusScreen.StatusScreen, tslib.__assign({ topAddons: topAddon }, restProps));
};

exports.ERROR_ICONS_MAP = ERROR_ICONS_MAP;
exports.StatusScreenError = StatusScreenError;
